import { NumericFormat } from 'react-number-format';
import DOMPurify from "dompurify";

import classes from './AddonsProduct.module.css';

import AddToCart from '../ui/AddToCart';
import Image from '../ui/Image';

function AddonsProduct(props) {
	return (
		<div>
			<div className={classes.image}>
				<Image
					key={props.product.id}
					id={props.product.id}
					name={props.product.name}
					filename={props.product.filename}
					filetype={props.product.filetype}
					filename_webp={props.product.filename_webp}
				/>
			</div>
			<div className={classes.content}>
				<h3 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.product.name) }}></h3>
				<span>{props.product._netsuite_externalId} </span>
			</div>
			<div>
				{(props.product.pricing.highest.price > props.product.pricing.lowest.price) && 
					<strike className={classes.basePrice}>
						<NumericFormat value={props.product.pricing.highest.price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
					</strike>
				}
				<div>
					<div className={classes.price}>
						<NumericFormat value={props.product.pricing.lowest.price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
					</div>
					<div className={classes.basePrice + ' ' + ((props.product.pricing.highest.price > props.product.pricing.lowest.price) ? 'hidden' : '')}>
						<span>&nbsp;</span>
					</div>
				</div>
				<input type='hidden' id='quantity' defaultValue="1"/>
			</div>
			<div className={classes.actions}>
				<AddToCart product={props.product} showQuantity={false} disableAfterAdd={true} totalSteps={1} step={1}/>
			</div>
		</div>
	);
}

export default AddonsProduct;